<div class="mx-auto max-w-screen-md">
	<vp-link
		[buttonClassName]="buttonClassName()"
		[editableInStoryblok]="_editable()"
		[link]="anchorLink()"
		type="button"
	>
		{{ text() }}
	</vp-link>
</div>
